import { render, staticRenderFns } from "./HighlightSaved.vue?vue&type=template&id=4df37df6&"
import script from "./HighlightSaved.vue?vue&type=script&lang=js&"
export * from "./HighlightSaved.vue?vue&type=script&lang=js&"
import style0 from "./HighlightSaved.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports